import React, { Component } from 'react';
import { connect } from 'react-redux';

import Paper from '@material-ui/core/Paper';
import SearchIcon from '@material-ui/icons/Search';
import InputAdornment from '@material-ui/core/InputAdornment';
import { withStyles } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

import SelectTable from '../../components/DataTable/SelectTable';
import AllowanceDialog from '../../components/Allowance/AllowanceDialog';
import { fetchEmployees } from '../../store/actions/employee';
import ContentHeader from '../../components/ContentHeader/ContentHeader';

const styles = theme => ({
  input: {
    width: '40%',
    margin: theme.spacing(3),
  },
  button: {
    margin: theme.spacing(1),
    border: '1px solid',
    borderColor: theme.palette.grey[400],
  },
  optionsButton: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
});

class CreateAllowance extends Component {
    state = {
      openModal: false,
      searchQuery: '',
      selected: [],
    };

    componentDidMount() {
      this.props.onFetchEmployees();
    }

      handleActionCancel = () => {
        this.setState({ openModal: false });
      };

      handleActionClick = () => {
        this.setState({ openModal: true });
      };

      handleInputChange = name => (event) => {
        this.setState({ [name]: event.target.value });
      };

      createVacation = () => {
        this.props.onCreateVacations();
      }

      handleSelectAll = (event, checked, searchSelect) => {
        const searchIndex = searchSelect.map(employee => employee.id);

        if (checked) {
          const newSelected = this.state.selected.slice();

          if (searchIndex) {
            if (this.state.selected.indexOf(searchIndex[0]) === -1) {
              this.props.employees.map(employee =>
                (searchIndex.indexOf(employee.id) > -1 && newSelected.indexOf(employee.id) === -1
                  ? newSelected.push(employee.id)
                  : null));
            } else {
              this.props.employees.map(employee =>
                (searchIndex.indexOf(employee.id) > -1
                  ? newSelected.splice(newSelected.indexOf(employee.id), 1)
                  : null));
            }
          }

          this.setState({ selected: newSelected });
        } else if (searchIndex.length === this.props.employees.length) {
          this.setState({ selected: [] });
        } else {
          const newSelected = this.state.selected.slice();
          this.props.employees.map(employee =>
            (searchIndex.indexOf(employee.id) > -1
              ? newSelected.splice(newSelected.indexOf(employee.id), 1)
              : null));

          this.setState({ selected: newSelected });
        }
      };

      handleSelect = (event, id) => {
        const { selected } = this.state;
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
          newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
          newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
          newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
          newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
        }

        this.setState({ selected: newSelected });
      };

      isSelected = id => this.state.selected.indexOf(id) !== -1;

      render() {
        const { searchQuery, selected, openModal } = this.state;
        const {
          classes, employees, loading,
        } = this.props;

        const columns = [
          { name: 'name', label: 'Nome' },
          { name: 'cpf', label: 'CPF' },
          { name: 'phone', label: 'Telefone' },
          { name: 'department', label: 'Departamento' },
        ];

        const searchFields = ['name', 'cpf', 'department', 'phone', '_departamento'];

        return (
          <React.Fragment>
            <ContentHeader
              title="Cadastrar Abono"
              subtitle="Selecione o(s) funcionário(s) para adicionar um abono"
            >
              <Button variant="contained" color="primary" onClick={this.handleActionClick}>
                <AddIcon /> ADICIONAR
              </Button>
            </ContentHeader>

            <Paper elevation={2}>
              <TextField
                className={classes.input}
                value={searchQuery}
                onChange={this.handleInputChange('searchQuery')}
                placeholder="Buscar"
                type="text"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon color="disabled" />
                    </InputAdornment>
                  ),
                }}
              />

              <SelectTable
                rows={employees}
                columns={columns}
                loading={loading}
                searchFields={searchFields}
                onSelect={this.handleSelect}
                onSelectAll={this.handleSelectAll}
                checkSelect={this.isSelected}
                numSelected={selected.length}
                searchQuery={searchQuery.toUpperCase()}
              />
            </Paper>

            <AllowanceDialog
              open={openModal}
              onClose={this.handleActionCancel}
              title="Cadastrar"
              editField=""
              loading={loading}
              confirmClick={this.createVacation}
              employees={selected}
            />

          </React.Fragment>
        );
      }
}

const mapStateToProps = state => ({
  loading: state.general.loading,
  employees: state.employee.employees,
});

const mapDispatchToProps = dispatch => ({
  onFetchEmployees: () => dispatch(fetchEmployees()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(CreateAllowance));
